

class AuthenticationHelper {

    private listeners: Array<() => void> = [];

    public notifyUnauthorized() {
        this.listeners.forEach(listener => listener());
    }

    public subscribe(listener: () => void) {
        this.listeners.push(listener);
        
        return () => {
            this.listeners = this.listeners.filter(l => l !== listener);
        }
    }
}

const authenticationHelper = new AuthenticationHelper();
export default authenticationHelper;
